import { render, staticRenderFns } from "./DocumentToDownloadPanel.vue?vue&type=template&id=308df297&"
import script from "./DocumentToDownloadPanel.vue?vue&type=script&lang=js&"
export * from "./DocumentToDownloadPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports